import { useEffect, useState } from "react";
import { api, formatCurrency, formatDate } from "../lib/api";
import { PageHeader, StatusBadge } from "../components/ui-kit";
import { useAuth } from "../lib/auth";

export default function ReportsPage() {
  const { user } = useAuth();
  const isTech = user?.role === "tecnico";
  const [techs, setTechs] = useState([]);
  const [tid, setTid] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!isTech) api.get("/users").then((r) => setTechs(r.data.filter((u) => u.role === "tecnico")));
    load();
  }, [isTech]);

  const load = () => {
    const params = new URLSearchParams();
    if (!isTech && tid) params.append("technician_id", tid);
    if (from) params.append("from_date", from);
    if (to) params.append("to_date", to);
    api.get(`/reports/production?${params.toString()}`).then((r) => setData(r.data));
  };

  return (
    <div data-testid="reports-page">
      <PageHeader
        eyebrow="Analytics"
        title={isTech ? "Minha Produção" : "Relatórios de Produção"}
      >
        Somente OTs concluídas são contabilizadas.
      </PageHeader>

      <div className="card p-4 mb-6 flex gap-3 flex-wrap items-end">
        {!isTech && (
          <div>
            <label className="label-caps block mb-1">Técnico</label>
            <select className="select w-56" value={tid} onChange={(e) => setTid(e.target.value)} data-testid="report-tech">
              <option value="">Todos</option>
              {techs.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
        )}
        <div><label className="label-caps block mb-1">De</label><input type="date" className="input" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="report-from" /></div>
        <div><label className="label-caps block mb-1">Até</label><input type="date" className="input" value={to} onChange={(e) => setTo(e.target.value)} data-testid="report-to" /></div>
        <button className="btn btn-primary" onClick={load} data-testid="report-generate">Gerar</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <Metric label="Total OTs" value={data?.count ?? "-"} />
        <Metric label="Faturamento Total" value={data ? formatCurrency(data.total_value) : "-"} />
        <Metric label="Últimos 7 dias" value={data ? `${data.weekly.count} OTs · ${formatCurrency(data.weekly.value)}` : "-"} />
        <Metric label="Mês atual" value={data ? `${data.monthly.count} OTs · ${formatCurrency(data.monthly.value)}` : "-"} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card">
          <div className="px-5 py-4 border-b" style={{ borderColor: "var(--border)" }}><h3 className="label-caps">Por Dia</h3></div>
          <table className="data">
            <thead><tr><th>Data</th><th>OTs</th><th>Valor</th></tr></thead>
            <tbody>
              {(data?.daily || []).slice(-14).reverse().map((d) => (
                <tr key={d.date}><td>{d.date}</td><td className="mono">{d.count}</td><td className="mono">{formatCurrency(d.value)}</td></tr>
              ))}
              {(!data || data.daily?.length === 0) && <tr><td colSpan={3} className="text-center py-8 text-sm" style={{ color: "var(--text-mute)" }}>Sem dados no período.</td></tr>}
            </tbody>
          </table>
        </div>

        <div className="card">
          <div className="px-5 py-4 border-b" style={{ borderColor: "var(--border)" }}><h3 className="label-caps">OTs Concluídas</h3></div>
          <table className="data">
            <thead><tr><th>OT</th><th>Data</th><th>Cliente</th><th>Valor</th><th>Status</th></tr></thead>
            <tbody>
              {(data?.ots || []).slice(0, 20).map((o) => (
                <tr key={o.id}>
                  <td className="mono">{o.number}</td>
                  <td>{formatDate(o.date)}</td>
                  <td>{o.client_name}</td>
                  <td className="mono">{formatCurrency(o.total_value)}</td>
                  <td><StatusBadge status={o.status} /></td>
                </tr>
              ))}
              {(!data || data.ots?.length === 0) && <tr><td colSpan={5} className="text-center py-8 text-sm" style={{ color: "var(--text-mute)" }}>Sem OTs no período.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function Metric({ label, value }) {
  return (
    <div className="card p-4">
      <div className="stat-label mb-2">{label}</div>
      <div className="stat-value" style={{ fontSize: 22 }}>{value}</div>
    </div>
  );
}
